import {
  EBodyStyle,
  EConditionType,
  EAuctionStatus,
}                  from '@enums/auction';
import { IOption } from '@typings/components';

export const bodyStyleOptions: IOption[] = [
  { label: EBodyStyle.Car,          value: EBodyStyle.Car },
  { label: EBodyStyle.SUV,          value: EBodyStyle.SUV },
  { label: EBodyStyle.Truck,        value: EBodyStyle.Truck },
  { label: EBodyStyle.Van,          value: EBodyStyle.Van },
  { label: EBodyStyle.Motorcycle,   value: EBodyStyle.Motorcycle },
  { label: EBodyStyle.Watercraft,   value: EBodyStyle.Watercraft },
  { label: EBodyStyle.ATV,          value: EBodyStyle.ATV },
  { label: EBodyStyle.RV,           value: EBodyStyle.RV },
  { label: EBodyStyle.Agriculture,  value: EBodyStyle.Agriculture },
  { label: EBodyStyle.Construction, value: EBodyStyle.Construction },
  { label: EBodyStyle.Other,        value: EBodyStyle.Other },
];

export const exteriorConditionOptions: IOption[] = [
  { label: 'Excellent - Paint glossy no dents',   value: EConditionType.Excellent },
  { label: 'Good - Minimum blemishes',            value: EConditionType.Good },
  { label: 'Fair - Some cosmetic defects',        value: EConditionType.Fair },
  { label: 'Poor - Significant cosmetic defects', value: EConditionType.Poor },
];

export const interiorConditionOptions: IOption[] = [
  { label: 'Excellent - Free of any wear or visible defects', value: EConditionType.Excellent },
  { label: 'Good - Minor (if any) blemishes',                 value: EConditionType.Good },
  { label: 'Fair - Some cosmetic defect',                     value: EConditionType.Fair },
  { label: 'Poor - Cosmetic or functional defects',           value: EConditionType.Poor },
];

export const mechanicalConditionOptions: IOption[] = [
  { label: 'Excellent - Like new conditions, matching tires, no leaks', value: EConditionType.Excellent },
  { label: 'Good - Free of major issues, good tire tread remaining',    value: EConditionType.Good },
  { label: 'Fair - Check Engine light or in need of tires',             value: EConditionType.Fair },
  { label: 'Poor - Rough starting and/or running',                      value: EConditionType.Poor },
];

export const AUCTION_STATUS_NAME: Record<EAuctionStatus, string> = {
  [EAuctionStatus.Technical]          : 'Technical',
  [EAuctionStatus.SavedDraft]         : 'Saved Draft',
  [EAuctionStatus.SavedDraftNoPhotos] : 'Saved Draft - No Photos',
  [EAuctionStatus.Pending]            : 'Pending',
  [EAuctionStatus.PendingNoPhotos]    : 'Pending - No Photos',
  [EAuctionStatus.Active]             : 'Active',
  [EAuctionStatus.Ended]              : 'Ended',
  [EAuctionStatus.Canceled]           : 'Canceled',
  [EAuctionStatus.Archived]           : 'Archived',
  [EAuctionStatus.Error]              : 'Error',
  [EAuctionStatus.Exported]           : 'Exported',
};
